import { routes } from '../constants';
import type { User } from '../types/User';
import { getDefaultSearchResultTab } from './getDefaultSearchResultTab';
import searchFiltersToQuery from './searchFiltersToQuery';
import searchResultsStorageManager from './searchResultsStorageManager';

const getSearchPageUrl = (user?: User): string => {
	const storageSessionSearchFilters = searchResultsStorageManager.getSearchFilters();
	const searchTabKey = searchResultsStorageManager.getSearchTabKey();
	const tabPath = searchTabKey || getDefaultSearchResultTab(user);
	const filtersQuery = searchFiltersToQuery(storageSessionSearchFilters);
	return filtersQuery
		? `/${routes.search.root}/${tabPath}?${filtersQuery}`
		: `/${routes.search.root}/${tabPath}`;
};

export default getSearchPageUrl;
